import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function GifBoxIcon(props: IconProps) {
    return <Icon {...props} iconKey={"gif_box"}/>
}
